export class UserDisplayHeader {
    completeName: string;
    email: string;
}  